<template>
  <div>
    <shop-header :store-id="storeid" />
    <form @submit.prevent="placeOrder">
      <div class="container main-container">
        <div class="row">
          <div class="col-sm-7 col-xl-8">
            <div class="bg-white py-4 mb-2">
              <div
                v-if="!user && viewConfig.LogIn"
                class="alert alert-primary p-4 mt-4 alert-color mx-4"
                :style="desktopStyles.alertInfoBackGround"
                role="alert"
              >
                <a
                  href="#"
                  :style="desktopStyles.btn"
                  class="btn btn-primary pr-2"
                  @click="setShowOverlay(true)"
                >{{ $t("message.login") }}</a>
                <span class="pl-2">
                  {{
                  $t("message.placeAnOrderAsGuestWithoutCreatingAccount")
                  }}
                </span>
              </div>

              <div class="p-4 d-flex justify-content-center">
                <div class="w-85">
                  <h4
                    v-show="
                      !(
                        !viewConfig.Delivery &&
                        !viewConfig.PickUp &&
                        !viewConfig.DeliverToRoom &&
                        !viewConfig.EatIn
                      )
                    "
                  >{{ $t("message.gettingYourMeal") }}</h4>
                  <div class="btn-group" role="group" aria-label="Basic example">
                    <button
                      v-show="viewConfig.Delivery"
                      :style="btnStyle(isDelivery)"
                      type="button"
                      class="btn"
                      @click="deliveryMode"
                    >{{ $t("message.delivery") }}</button>
                    <button
                      v-if="viewConfig.PickUp && !pickupDisabled"
                      :style="btnStyle(isPickup)"
                      type="button"
                      class="btn"
                      @click="pickupMode"
                    >{{ $t("message.pickUp") }}</button>
                    <button
                      v-if="viewConfig.DeliverToRoom && !deliveryDisabled"
                      :style="btnStyle(isChargeToRoom)"
                      type="button"
                      class="btn"
                      @click="chargeToRoomMode"
                    >{{ $t("message.deliverToRoom") }}</button>
                    <button
                      v-if="viewConfig.EatIn"
                      :style="btnStyle(isEatIn)"
                      type="button"
                      class="btn"
                      @click="eatInMode"
                    >{{ $t("message.dineIn") }}</button>
                  </div>
                  <div v-show="!isChargeToRoom && (isDelivery || isPickup)" class="form-row mt-4">
                    <div
                      class="form-group col-6"
                      v-if="viewConfig.ShowDeliveryDatePicker && isDelivery"
                    >
                      <label for="date-select">
                        {{
                        $t("message.deliveryDate")
                        }}
                      </label>
                      <date-picker
                        @closed="setPickupDeliveryTimes(deliveryDate)"
                        v-model="deliveryDate"
                        :disabledDates="disabledDates"
                        bootstrap-styling
                      ></date-picker>
                    </div>
                    <div
                      class="form-group col-6"
                      v-if="viewConfig.ShowPickupDatePicker && isPickup"
                    >
                      <label for="date-select">
                        {{
                        $t("message.pickupDate")
                        }}
                      </label>
                      <date-picker
                        @closed="setPickupDeliveryTimes(pickupDate)"
                        v-model="pickupDate"
                        :disabledDates="disabledDates"
                        bootstrap-styling
                      ></date-picker>
                    </div>
                    <div class="form-group col-6">
                      <label v-show="isDelivery" for="time-select">
                        {{
                        $t("message.deliveryTime")
                        }}
                      </label>
                      <label v-show="isPickup" for="time-select">
                        {{
                        $t("message.pickupTime")
                        }}
                      </label>
                      <select id="time-select" v-model="selectedTime" class="form-control">
                        <option v-for="(t, index) in dtimes" :key="index" :value="t">{{ t }}</option>
                      </select>
                    </div>
                  </div>

                  <pickup-address
                    v-show="
                      isPickup &&
                        !pickupDisabled &&
                        !viewConfig.HideAddressOnPickup
                    "
                    :store-doc="currentStoreDoc"
                  />
                  <my-detail
                    v-if="!user && !currentStoreDoc.ChargeToRoom && !isEatIn"
                    ref="myDetails"
                    :edit-model="detailModel"
                    :charge-to-room="currentStoreDoc.ChargeToRoom"
                    @save-user="saveUser"
                    :for-gift="false"
                  />
                  <delivery-address
                    v-show="isDelivery"
                    ref="deliveryAddress"
                    header-title="Delivery"
                    :edit-model="deliveryAddressModel"
                  />
                  <room-delivery
                    v-if="currentStoreDoc.ChargeToRoom && !isEatIn"
                    ref="roomDelivery"
                    :edit-model="roomDeliveryModel"
                  />
                  <eat-in ref="eatIn" @save-user="saveUser" v-if="isEatIn" :edit-model="eatInModel"></eat-in>
                  <div
                    :class="isChargeToRoom ? 'mt-4' : 'mt-2'"
                    v-if="
                      currentStoreDoc.ChargeToRoom ||
                        payByPoint.canPay ||
                        isPayByCashEnable ||
                        viewConfig.EnableAlipayPayment ||
                        viewConfig.EnableWechatPayment
                    "
                  >
                    <div v-if="currentStoreDoc.ChargeToRoom" class="form-row">
                      <div class="custom-control custom-radio col-md-8 ml-4">
                        <input
                          id="chargeToRoomInput"
                          :checked="paymentMethod == 0"
                          type="radio"
                          name="customCheckbox"
                          class="custom-control-input"
                          @change="paymentMethod = 0"
                          :disabled="!ChargeToRoomRadioValue"
                        />
                        <label class="custom-control-label" for="chargeToRoomInput">
                          {{
                          $t(
                          "message.chargeToRoomGuestsWithAuthorisedCreditCardsOnly"
                          )
                          }}
                        </label>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="custom-control custom-radio col-md-8 ml-4">
                        <input
                          id="payByCardInput"
                          :checked="paymentMethod == 1"
                          type="radio"
                          name="customCheckbox"
                          class="custom-control-input"
                          @change="payByCardMode"
                        />
                        <label
                          class="custom-control-label"
                          for="payByCardInput"
                        >{{ $t("message.payByCard") }}</label>
                      </div>
                    </div>
                    <div v-if="payByPoint.canPay" class="form-row">
                      <div class="custom-control custom-radio col-md-8 ml-4">
                        <input
                          id="payByPointsInput"
                          :checked="paymentMethod == 2"
                          type="radio"
                          name="customCheckbox"
                          class="custom-control-input"
                          @change="payByPointMode"
                        />
                        <label class="custom-control-label" for="payByPointsInput">
                          {{ $t("message.payByLoyaltyPoints") }}
                          <span
                            class="payByPoint-span text-success"
                          >
                            -{{
                            payByPoint.cardValueInPoint | formatNumber
                            }}
                            pts ({{ getTotalPrice | formatMoney }})
                          </span>
                        </label>
                      </div>
                    </div>
                    <div v-if="isPayByCashEnable" class="form-row">
                      <div class="custom-control custom-radio col-md-8 ml-4">
                        <input
                          id="payByCashInput"
                          :checked="paymentMethod == 3"
                          type="radio"
                          name="customCheckbox"
                          class="custom-control-input"
                          @change="payByCashMode"
                        />
                        <label
                          class="custom-control-label"
                          for="payByCashInput"
                        >{{ $t("message.payByCash") }}</label>
                      </div>
                    </div>
                    <div v-if="viewConfig.EnableAlipayPayment" class="form-row">
                      <div class="custom-control custom-radio col-md-8 ml-4">
                        <input
                          id="payByAlipayInput"
                          :checked="paymentMethod == 4"
                          type="radio"
                          name="customCheckbox"
                          class="custom-control-input"
                          @change="payByAlipayMode"
                        />
                        <label
                          class="custom-control-label"
                          for="payByAlipayInput"
                        >{{ $t("message.payByAlipay") }}</label>
                      </div>
                    </div>
                    <div v-if="viewConfig.EnableWechatPayment" class="form-row">
                      <div class="custom-control custom-radio col-md-8 ml-4">
                        <input
                          id="payByWechatInput"
                          :checked="paymentMethod == 5"
                          type="radio"
                          name="customCheckbox"
                          class="custom-control-input"
                          @change="payByWechatMode"
                        />
                        <label
                          class="custom-control-label"
                          for="payByWechatInput"
                        >{{ $t("message.payByWechat") }}</label>
                      </div>
                    </div>
                  </div>
                  <div v-if="showPayment">
                    <payment
                      v-show="
                        (!currentStoreDoc.ChargeToRoom &&
                          !payByPoint.canPay &&
                          !isPayByCashEnable &&
                          !viewConfig.EnableAlipayPayment &&
                          !viewConfig.EnableWechatPayment) ||
                          paymentMethod == 1
                      "
                      ref="payment"
                      :user="user"
                      :dbuser="userInfo"
                      :edit-model="paymentModel"
                      @save-credit="saveCredit"
                    />
                  </div>
                  <div>
                    <div class="form-row" v-show="viewConfig.ShowNotes">
                      <div class="form-group col-sm-12">
                        <h4>{{ $t("message.notes") }}</h4>
                        <textarea
                          id="notes"
                          maxlength="300"
                          v-model="notes"
                          name="notes"
                          type="text"
                          class="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div v-show="error" class="w-100 mt-4">
                    <div class="alert alert-danger" role="alert">
                      <strong v-html="error"></strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="shopping-cart" class="col-sm-5 col-xl-4">
            <ShoppingCart
              ref="shoppingCart"
              :proccessing="proccessing"
              :order-type="orderType"
              order-mode
            />
            <BecomeMember
              @setBecomeMemberResult="result => setBecomeMemberResult(result)"
              ref="becomeMember"
              v-if="showBecomeMember"
            />
          </div>
        </div>
      </div>
    </form>
    <shopfooter />
  </div>
</template>

<script>
import MyDetail from "./partials/MyDetail";
import ShoppingCart from "./../shopping-cart/ShoppingCart";
import DeliveryAddress from "./partials/DeliveryAddress";
import Payment from "./partials/Payment";
import PickupAddress from "./partials/PickupAddress";
import RoomDelivery from "./partials/RoomDelivery";
import EatIn from "./partials/EatIn";
import ShopHeader from "./../partials/shopheader";
import shopfooter from "./../../shared/shopfooter";
import { getTrackingOrder } from "../../../api/services/orderService.js";
import DatePicker from "vuejs-datepicker";
import shared from "../../../sharedscripts/shop/Checkout/Checkout.js";
import BecomeMember from "../../../components/shop/register/BecomeMember";
import { mapGetters, mapMutations } from "vuex";
import uuid from "uuid/v1";
export default {
  components: {
    MyDetail,
    DeliveryAddress,
    Payment,
    PickupAddress,
    RoomDelivery,
    EatIn,
    ShoppingCart,
    ShopHeader,
    shopfooter,
    DatePicker,
    BecomeMember
  },
  props: {
    storeid: {
      type: String,
      default: ""
    },
    forGiftCart: {
      type: Boolean,
      default: false
    },
    orderid: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      showBecomeMember: false,
      userIsExist: false,
      error: "",
      isDelivery: false,
      isPickup: false,
      isChargeToRoom: false,
      isEatIn: false,
      dtimes: [],
      selectedTime: "",
      deliveryDate: "",
      pickupDate: "",
      notes: "",
      disabledDates: {},
      detailModel: {
        FirstName: "",
        LastName: "",
        Email: "",
        Phone: ""
      },
      paymentModel: {
        CardHolder: "",
        CardNumber: "",
        ExpireDate: "",
        CVV: "",
        SelectedCard: null
      },
      deliveryAddressModel: {
        StreetAddress: "",
        PostalCode: "",
        CityTown: "",
        DeliveryInstructions: "",
        State: "",
        Altitude: "",
        Longitude: ""
      },
      roomDeliveryModel: {
        RoomNumber: "",
        FirstName: "",
        LastName: "",
        Email: ""
      },
      eatInModel: {
        TableNumber: "",
        FirstName: "",
        LastName: "",
        Email: ""
      },
      registerNew: false,
      saveCard: false,
      paymentMethod: 1,
      deliveryDisabled: false,
      pickupDisabled: false,
      userInfo: {},
      proccessing: false,
      orderObject: null,
      guestUserId: null
    };
  },

  computed: {
    ...shared.computed,
    ...mapGetters(["desktopStyles"])
  },
  watch: {
    holder() {
      this.paymentModel.CardHolder = this.holder;
    },
    pickupDate() {
      this.pickupSurcharge();
    },
    deliveryDate() {
      this.deliverySurcharge();
    }
  },
  created() {
    this.setRoomNoFromStorage();
  },
  mounted() {
    let coupon = window.localStorage.getItem("coupon");
    if (coupon) {
      this.$refs.shoppingCart.applyCoupon(coupon);
    }

    this.setPickupDeliveryDates();
    this.setPickupDeliveryTimes(this.deliveryDate);
    this.computeRules();

    this.userInfo = this.dbuser;
    if (!this.userInfo) this.userInfo = {};
    this.initModel();
    if (localStorage.getItem("checkoutData")) {
      var initialState = function() {
        return JSON.parse(localStorage.getItem("checkoutData"));
      };
      Object.assign(this.$data, initialState());
      this.showBecomeMember = false;
      this.pickupDate = new Date(this.pickupDate);
      this.deliveryDate = new Date(this.deliveryDate);
    }
    if (this.$route.query.result) {
      if (
        this.$route.query.result === "SUCCESS" &&
        this.$route.query.merchant_trade_no
      ) {
        this.processPayment(
          this.$route.query.merchant_trade_no,
          this.guestUserId
        );
      } else {
        this.error = this.$route.query.trade_status;
      }
    }
    if (this.orderid) {
      var that = this;
      getTrackingOrder(this.user.id, this.orderid)
        .get()
        .then(result => {
          if (result.exists) {
            result = result.data();
            that.clearAllOrders();
            result.OrderItems.forEach(orderitem => {
              var product = that.getProductOutcomeInfo(orderitem.Product_ID);
              var modifiers = orderitem.OrderExtras.map(m => {
                var result = {
                  quantity: m.Quantity,
                  TaxRate:
                    m.UsingUnitPrice > 0 ? m.FinalTax / m.UsingUnitPrice : 0,
                  Price: m.UsingUnitPrice,
                  ID: m.Extra_ID,
                  Name: m.Name
                };
                if (m.ChildrenOrderExtras)
                  result.selectedSubmodifiers = m.ChildrenOrderExtras.map(
                    m2 => {
                      return {
                        quantity: m2.Quantity,
                        TaxRate:
                          m2.UsingUnitPrice > 0
                            ? m2.FinalTax / m2.UsingUnitPrice
                            : 0,
                        Price: m2.UsingUnitPrice,
                        ID: m2.Extra_ID,
                        Name: m2.Name
                      };
                    }
                  );
                return result;
              });
              that.Add_ProductItem({
                item: {
                  id: orderitem.Product_ID,
                  uniqueId: uuid(),
                  code: product.ProductCode,
                  name: product.Name,
                  description: product.ShortDescription,
                  photoUrl: product.PhotoUrl,
                  tax: product.TaxRate,
                  price: orderitem.UsingUnitPrice,
                  categoryId: orderitem.CategoryId,
                  categoryName: orderitem.CategoryName
                },
                ProductCategoryIDs: product.ProductCategoryIDs,
                ProductTagIDs: product.ProductTagIDs,
                quantity: orderitem.Quantity,
                modifiers: modifiers
              });
            });
            that.applyPriceTriggers();
            switch (result.OrderType) {
              case 10:
                that.deliveryMode();
                that.deliveryAddressModel.StreetAddress =
                  result.DeliveryAddress.Address;
                that.deliveryAddressModel.Altitude =
                  result.DeliveryAddress.Altitude;
                that.deliveryAddressModel.Longitude =
                  result.DeliveryAddress.Longitude;
                that.deliveryAddressModel.PostalCode =
                  result.DeliveryAddress.Postcode;
                that.deliveryAddressModel.State = result.DeliveryAddress.State;
                that.deliveryAddressModel.CityTown =
                  result.DeliveryAddress.Suburb;
                break;
              case 2:
                that.eatInMode();
                if (result.Tables && result.Tables[0] && result.Tables[0].Name)
                  that.eatInModel.TableNumber = result.Tables[0].Name;
                break;
              case 3:
                that.chargeToRoomMode();
                break;
            }
          }
        });
    }
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      let room = to.query.room | localStorage.getItem("room");
      if (room) {
        vm.$data.roomDeliveryModel.RoomNumber = room;
      }
      let table = to.query.table | localStorage.getItem("table");
      if (table) {
        vm.$data.eatInModel.TableNumber = table;
        vm.$data.isEatIn = true;
      }
    });
  },
  methods: {
    ...shared.methods,
    syncFirstName(firstName) {
      this.detailModel.FirstName = firstName;
      this.roomDeliveryModel.FirstName = firstName;
      this.eatInModel.FirstName = firstName;
    },
    btnStyle(isPrimary) {
      var style = [];
      if (isPrimary) {
        style.push(this.desktopStyles.btn);
      }
      return style;
    },
    ...mapMutations(["setShowOverlay"])
  }
};
</script>
